import React, { Suspense, lazy, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { Routes, Route } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const MerchantPage = lazy(() => import("../pages/merchantPages/index"));
const ExpiredPage = lazy(() => import("../pages/KMC/ExpiredPage/ExpiredPage"));
const SessionWrapper = lazy(() => import("../pages/KMC/ExpiredPage/SessionWrapper"));
const NotFound = lazy(() => import("../pages/KMC/PageNotFound/NotFound"));
const MerchantPageRoutes = () => {
  const { checksum } = useSelector((state) => state.culturalHeritageReducer);
  const { i18n } = useTranslation();

  useEffect(() => {
    if (checksum?.acceptLanguage) {
      i18n.changeLanguage(checksum.acceptLanguage);
    }
  }, [checksum?.acceptLanguage, i18n]);

  return (
    <>
      <Suspense fallback={<div className="loading"></div>}>
        <Routes>
          {/* Property Tax Route */}
          <Route path="cb/page/payment/txn-status/:checksum">
            <Route index element={<MerchantPage />} />
            <Route path="expired" element={<ExpiredPage />} />
            <Route path="*" element={<NotFound />} />
          </Route>
        </Routes>
      </Suspense>

      {/* Toast Notifications */}
      <ToastContainer />
    </>
  );
};

export default MerchantPageRoutes;
